import { useMemo, useCallback } from "react"
import { Box, useTheme } from "@mui/material"
import { Link, useNavigate } from "react-router-dom"
import { PromotionCard } from "components/domains/promotions"
import { EmptyData } from "components/EmptyData"
import { useTranslation } from "providers/i18n"
import { PercentIcon } from "components/icons"
import { Carousel } from "../../components/Carousel/Carousel"
import { CarouselItem } from "../../components/Carousel"
import { Head } from "components/Head"
import { usePromotion } from "hooks/promotion/usePromotion"
import { getIcon } from "utils/icon"
import { useVenue } from "providers/venue"
import { VenueSelector } from "components/VenueSelector"
import {
  CategoryFilterBar,
  CategoryFilterChip,
} from "components/CategoryFilterBar"

export const Promotions = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const {
    filteredPromotions,
    changeVenueFilter,
    locationVenueId,
    venueFilter,
  } = usePromotion()
  const { venues, isMultiVenueProject } = useVenue()

  const theme = useTheme()
  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.promotions) || <PercentIcon />,
    [theme]
  )

  const { styleOverrides } = theme.components?.[`PromotionPage`] || {}
  const {
    root,
    carouselContainer,
    carousel,
    cardListContainer,
    categoryFilterBarContainer,
    emptyDataContainer,
    venueSelector,
  } = styleOverrides

  const handleClickSlide = useCallback(
    (_splide, { slide }, _event) => {
      navigate(slide.getAttribute("link"))
    },
    [navigate]
  )

  if (!filteredPromotions || filteredPromotions?.length === 0)
    return (
      <>
        <Head title={t("Promotions")} />
        <Box sx={emptyDataContainer}>
          <EmptyData
            icon={emptyIcon}
            primary={t("Coming soon")}
            secondary={t("Check Back Soon")}
          />
          {isMultiVenueProject && (
            <Box sx={venueSelector}>
              <VenueSelector
                selectedVenue={venueFilter}
                venues={venues}
                onClickVenue={changeVenueFilter}
                currentVenue={locationVenueId}
              />
            </Box>
          )}
        </Box>
      </>
    )
  return (
    <>
      <Head title={t("Promotions")} />
      <Box sx={root}>
        <Box sx={categoryFilterBarContainer}>
          {
            // TODO: Add a condition
            false && (
              <CategoryFilterBar renderFilterButton={CategoryFilterChip} />
            )
          }
        </Box>
        <Box sx={cardListContainer}>
          {filteredPromotions.map((promotion) => (
            <Link to={`/promotions/${promotion.id}`} key={promotion.id}>
              <PromotionCard size="large" promotion={promotion} />
            </Link>
          ))}
        </Box>
        <Box sx={carouselContainer}>
          {filteredPromotions && filteredPromotions.length > 0 ? (
            <Carousel
              onClick={handleClickSlide}
              options={{
                type: "loop",
                pagination: true,
                focus: "center",
                autoplay: true,
                gap: "0",
              }}
              sx={carousel}
            >
              {filteredPromotions.map((promotion) => (
                <CarouselItem
                  link={`/promotions/${promotion.id}`}
                  key={promotion.id}
                >
                  <PromotionCard promotion={promotion} />
                </CarouselItem>
              ))}
            </Carousel>
          ) : (
            ""
          )}
        </Box>
        {isMultiVenueProject && (
          <Box sx={venueSelector}>
            <VenueSelector
              selectedVenue={venueFilter}
              venues={venues}
              onClickVenue={changeVenueFilter}
              currentVenue={locationVenueId}
            />
          </Box>
        )}
      </Box>
    </>
  )
}
